import { Theme, css } from '@emotion/react';

export const imageListDialogContent = () => css`
  overflow-x: hidden;
`;

export const chipLabel =
  (forceShowChipLabel: boolean) =>
  ({ breakpoints, spacing }: Theme) => [
    css`
      position: absolute;
      left: ${spacing(1.75)}px;
      bottom: ${spacing(1.5)}px;
      opacity: 0.7;
    `,
    !forceShowChipLabel &&
      css`
        ${breakpoints.up('sm')} {
          display: none;
        }
      `,
  ];
